import { render, staticRenderFns } from "./CompanySiteTypeBadge.vue?vue&type=template&id=54b71454&scoped=true"
import script from "./CompanySiteTypeBadge.vue?vue&type=script&lang=js"
export * from "./CompanySiteTypeBadge.vue?vue&type=script&lang=js"
import style0 from "./CompanySiteTypeBadge.vue?vue&type=style&index=0&id=54b71454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b71454",
  null
  
)

export default component.exports